import React, { useState } from 'react'
import {Fuel, Gauge, Calendar, ArrowRight} from 'lucide-react'
import VehicleModal, { VehicleSpec } from './VehicleModal'

export default function FeaturedVehicles() {
  const [selectedVehicle, setSelectedVehicle] = useState<VehicleSpec | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const vehicles: VehicleSpec[] = [
    {
      image: 'https://static.lumi.new/material/2e/2e9f09eb774aee4ad696e3785fec0f74.jpg',
      name: 'Audi S3 Sportback',
      fullName: 'Audi S3 Sportback IV 2.0 TFSI 310ch quattro S tronic',
      price: '40 990 \u20AC',
      year: '2021',
      mileage: '42 400 km',
      fuel: 'Essence',
      power: '310 ch',
      transmission: 'Automatique',
      badge: 'S-LINE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3156328105',
      specs: {
        color: 'Noir Mythic metallise',
        fiscalPower: '20 CV',
        doors: '5 portes',
        firstRegistration: '03/2022',
        warranty: '12 mois',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              'Systeme audio 10 haut-parleurs',
              'Systeme Hi-Fi Surround',
              'GPS cartographique',
              'Disque dur multimedia',
              'Radio / Radio numerique DAB',
              'Lecteur CD / Lecteur DVD',
              'Lecteur carte SD',
              'Fonction MP3',
              'Interface Media',
              'Prise USB',
              'Prise auxiliaire audio',
              'Kit mains-libres Bluetooth',
              'Commandes vocales',
              'Borne Wi-Fi',
              'Services connectes',
              'TMC (info trafic)',
              'Appel d\'urgence localise',
              'Appel d\'assistance localise'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Blocage electronique du differentiel',
              'Capteur de pluie',
              'Capteur de luminosite',
              'Chassis Sport',
              'Demarrage sans cle',
              'Follow me home',
              'Mode de conduite',
              'Palettes changement vitesses au volant',
              'Regulateur de vitesse adaptatif',
              'Suspensions Sport',
              'Systeme d\'acces sans cle'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Becquet arriere',
              'Boucliers avant et arriere couleur carrosserie',
              'Jantes aluminium',
              'Pare-brise acoustique',
              'Buses de lave-glace chauffantes',
              'Essuie-glace arriere',
              'Lave-phares',
              'Echappement a double sortie',
              'Sorties d\'echappement chromees',
              'Phares avant LED',
              'Feux de jour a LED',
              'Feux arriere a LED',
              'Feux de freinage d\'urgence',
              'Systeme d\'eclairage intelligent',
              'Retroviseurs electriques',
              'Retroviseurs degivrants',
              'Retroviseurs rabattables electriquement',
              'Retroviseurs rabattables automatiquement',
              'Retroviseurs indexes a la marche arriere',
              'Radar de stationnement avant',
              'Radar de stationnement arriere',
              'Systeme d\'assistance au stationnement',
              'Systeme de mesure de place disponible'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir central avant',
              'Climatisation automatique bi-zones',
              'Vitres avant electriques',
              'Vitres arriere electriques',
              'Ouverture des vitres sequentielle',
              'Vitres teintees',
              'Lunette arriere degivrante',
              'Filtre a pollen',
              'Prise 12V',
              'Porte-gobelets avant'
            ]
          },
          {
            category: 'Sieges',
            items: [
              'Sieges avant sport',
              'Siege conducteur reglable en hauteur',
              'Siege passager reglable en hauteur',
              'Banquette arriere 3 places',
              'Banquette arriere rabattable 60/40',
              'Fixations ISOFIX aux places arriere'
            ]
          },
          {
            category: 'Volant / Poste de conduite',
            items: [
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en hauteur et en profondeur',
              'Pedalier sport',
              'Retroviseur interieur electrochrome',
              'Ordinateur de bord',
              'Ecran multifonction couleur',
              'Compte-tours',
              'Indicateur de temperature exterieure',
              'Bacs de portes avant',
              'Bacs de portes arriere',
              'Poches aumonieres',
              'Boite a gants fermee',
              'Filets de coffre'
            ]
          },
          {
            category: 'Eclairage interieur',
            items: [
              'Lampes de lecture avant',
              'Lampes de lecture arriere',
              'Lampe de coffre',
              'Miroir de courtoisie conducteur eclaire',
              'Miroir de courtoisie passager eclaire',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Verrouillage automatique des portes en roulant'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS (systeme antiblocage des roues)',
              'ESP (controle electronique de stabilite)',
              'Antipatinage (ASR)',
              'Repartiteur electronique de freinage (EBD)',
              'Aide au freinage d\'urgence (AFU)',
              'Freinage automatique d\'urgence',
              'Systeme de prevention des collisions',
              'Alerte de franchissement involontaire de ligne (AFIL)',
              'Controle electronique de la pression des pneus',
              'Airbag conducteur',
              'Airbag passager deconnectable',
              'Airbags lateraux avant',
              'Airbags rideaux avant et arriere',
              'Alarme',
              'Antidemarrage electronique',
              'Troisieme ceinture de securite',
              'Temoin de bouclage des ceintures avant'
            ]
          }
        ],
        packs: [
          'Affichage tete haute',
          'Noir Mythic metallise',
          'Cle confort incluant deverrouillage du coffre par capteur (sans safelock)',
          'Crochet d\'attelage',
          'Fonction memoire pour sieges avant et retroviseurs exterieurs',
          'Jantes 19 5 bras en Y Gris Titane mat',
          'Toit ouvrant panoramique en verre',
          'Audi pre sense basic',
          'Phares Matrix LED + clignotants dyn AV/AR',
          'Appui lombaires a 4 axes pour les sieges avant',
          'Pack Eclairage d\'ambiance plus/multicolore',
          'Sieges avant chauffants',
          'Sieges avant reglables electriquement',
          'Vitrage Privacy',
          'Boitiers de retroviseurs ext noirs',
          'Pack Assistance Route',
          'Pack Esthetique noir'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/96/9680cf7303b07a7b2a974bec0f6192b9.jpeg',
      name: 'Mercedes CLA 35 AMG 4MATIC',
      fullName: 'Mercedes-Benz CLA (C118) 35 AMG 306ch 8G-DCT AMG 4Matic',
      price: '43 590 \u20AC',
      year: '2021',
      mileage: '82 500 km',
      fuel: 'Essence',
      power: '306 ch',
      transmission: 'Automatique',
      badge: 'AMG',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3158816096',
      specs: {
        color: 'Blanc',
        fiscalPower: '19 CV',
        doors: '4 portes',
        firstRegistration: '02/2021',
        warranty: '12 mois',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              'Android Auto',
              'Apple CarPlay',
              'Prise USB',
              'Prise USB-C'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Acces et demarrage sans cle',
              'Aide au demarrage en cote',
              'Choix du mode de conduite',
              'Essuie-glaces automatiques',
              'Palettes au volant',
              'Regulateur de vitesse adaptatif',
              'Systeme Start & Stop'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Aide au parking AV/AR',
              'Camera 360',
              'Hayon electrique',
              'Jantes aluminium',
              'Phares LED',
              'Phares adaptatifs',
              'Retroviseurs rabattables electriquement',
              'Retroviseurs electriques et degivrants',
              'Toit ouvrant panoramique',
              'Toit ouvrant electrique'
            ]
          },
          {
            category: 'Interieur',
            items: [
              '4 vitres electriques',
              'Climatisation bi-zone',
              'Eclairage d\'ambiance',
              'Sieges AV electriques',
              'Sieges chauffants AV',
              'Sieges a memoire',
              '4 roues motrices',
              'Boite de vitesse automatique',
              'GPS Couleur',
              'Mode Sport +',
              'Pack AMG',
              'Regulateur / Limiteur de vitesse',
              'Verrouillage centralise',
              'Volant multifonctions',
              'Etriers de freins rouges'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'Airbags',
              'Alerte franchissement de lignes',
              'Avertisseur d\'angle mort',
              'ESP',
              'Feux automatiques',
              'Fixations ISOFIX',
              'Lecture des panneaux',
              'Kit anti-crevaison'
            ]
          },
          {
            category: 'Autres equipements et informations',
            items: [
              'Double des cles',
              'Factures d\'entretien',
              'GPS Tactile',
              'Vehicule non fumeur'
            ]
          }
        ],
        packs: [
          'Integration smartphone',
          'Pilote auto regul distance Distronic',
          'Pack stationnement avec cameras panoramiques',
          'Jantes 19" 5 branches Noir mat/brillant',
          'Pack Cuir AMG',
          'Pack Sport Black AMG',
          'Lunette arriere surteintee',
          'Vitres arriere surteintees'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/98/98becedf4b7e0e7a5be502f7a072e076.jpeg',
      name: 'Audi e-tron GT Extended Quattro',
      fullName: 'Audi e-tron GT 476 ch Extended Quattro',
      price: '48 990 \u20AC',
      year: '2021',
      mileage: '60 000 km',
      fuel: 'Electrique',
      power: '476 ch',
      transmission: 'Automatique',
      badge: 'e-tron GT',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3158879623',
      specs: {
        color: 'Peinture metallisee Gris Daytona',
        fiscalPower: '10 CV',
        doors: '5 portes',
        firstRegistration: '06/2021',
        warranty: '12 mois',
        seats: '5 places',
        length: '4,99 metre(s)',
        weight: '2 275 kg',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              'Audi Smartphone Interface',
              'Navigation & Infotainment Audi connect',
              'Navigation MMI plus avec MMI touch response',
              'Systeme audiophonique Audi',
              'Bluetooth',
              'Radio numerique'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Cle confort',
              'Limiteur de vitesse',
              'Sieges sport'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Pack Assistance Stationnement',
              'Projecteurs a technologie LED',
              'Ouverture du coffre a distance',
              'Clignotants a LED integres',
              'Retroviseurs degivrants et rabattables electriquement',
              'Jantes alliage',
              'Systeme d\'aide au stationnement',
              'Toit panoramique'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Climatisation automatique Confort 3 zones',
              'Direction progressive',
              'Inserts decoratifs en bois de noyer Gris-brun naturel',
              'Pare-brise en vitrage athermique et acoustique',
              'Retroviseur interieur jour/nuit automatique sans encadrement',
              'Vitres athermiques',
              'Volant 3 branches multifonction plus en cuir avec palettes de changement de vitesse',
              'Climatisation',
              'Vehicule non fumeur',
              'Volant cuir',
              'Volant sport'
            ]
          },
          {
            category: 'Securite',
            items: [
              'Avertissement de franchissement de ligne',
              'Systeme quattro avec differentiel central autobloquant',
              'Protection proactive des occupants',
              'Systeme de controle de pression des pneus',
              'Airbag conducteur',
              'Airbag cote passager',
              'Airbags lateraux',
              'Fixations ISOFIX'
            ]
          }
        ],
        packs: [
          'Pack dynamique',
          'Affichage tete haute',
          'Pare-brise en vitrage acoustique et de confort climatique',
          'Pack Pilote (avec stationnement par smartphone)',
          'Pack Assistance Route',
          'Boitiers de retroviseurs exterieurs dans la couleur de la carrosserie',
          'Ciel de pavillon en tissu noir',
          'Cable de charge mode 3 / 11 kW',
          'Cable de recharge mode 3 pour recharge publique 22 kW',
          'Moulures de seuil avec insert en aluminium AV/AR',
          'Pompe a chaleur',
          'Prise de recharge CCS de type 2',
          'Prise domestique de type E/F 8A',
          'Regulation des feux de route',
          'Retroviseurs exterieurs reglables',
          'Set de reparation pour pneus',
          'Sideblades assortis a la couleur de la carrosserie',
          'Sieges chauffants conducteur et passager AV',
          'Systeme de recharge compact',
          'Systeme de recharge e-tron compact',
          'Tableau de bord en simili-cuir avec revetement',
          'Tableau de bord en simili-cuir noir',
          'Tapis complementaires AV et AR',
          'Transmission integrale Quattro',
          'Trousse de secours avec triangle de presignalisation',
          'Cockpit numerique',
          'Accoudoirs des portes',
          'Clignotants LED',
          'Lunette arriere degivrante',
          'Volant multifonctions'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/50/50531681c89efe289671aa94fe15829b.jpg',
      name: 'Audi Q2 35 TDI S Line',
      fullName: 'Audi Q2 35 TDI 150ch S line S tronic 7',
      price: '35 690 \u20AC',
      year: '2025',
      mileage: '13 500 km',
      fuel: 'Diesel',
      power: '150 ch',
      transmission: 'Automatique',
      badge: 'S-LINE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3156328105',
      specs: {
        color: 'Gris Daytona',
        fiscalPower: '8 CV',
        doors: '5 portes',
        firstRegistration: '10/2025',
        warranty: '24 mois',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '10 Haut parleurs',
              'Appel d\'Urgence Localise',
              'Commandes vocales',
              'Disque dur multimedia',
              'Fonction MP3',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Lecteur carte SD',
              'Prise USB',
              'Prise auxiliaire de connexion audio',
              'Radio',
              'Radio numerique DAB',
              'Services connectes',
              'Systeme Hi-Fi Surround'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Blocage electronique du differentiel',
              'Capteur de luminosite',
              'Capteur de pluie',
              'Commande du comportement dynamique',
              'Demarrage sans cle',
              'Follow me home',
              'Guidage pour manoeuvre de stationnement',
              'Limiteur de vitesse',
              'Regulateur de vitesse',
              'Systeme d\'acces sans cle',
              'Systeme de maintien du vehicule en cote'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Boucliers AV et AR couleur caisse',
              'Buses de lave-glace chauffantes',
              'Camera de recul',
              'Echappement a double sortie',
              'Essuie-glace arriere',
              'Feux arriere a LED',
              'Feux de jour a LED',
              'Filtre a particules',
              'Jantes Alu',
              'Phares avant LED',
              'Poignees ton carrosserie',
              'Radar de stationnement AR',
              'Radar de stationnement AV',
              'Repetiteurs de clignotant dans retro ext',
              'Retroviseurs degivrants',
              'Retroviseurs exterieurs electrochromes',
              'Retroviseurs rabattables electriquement',
              'Retroviseurs electriques',
              'Systeme d\'eclairage intelligent'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir central AV',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 60/40',
              'Banquette AR rabattable',
              'Boite a gant fermee',
              'Clim automatique',
              'Compte tours',
              'Eclairage d\'ambiance',
              'Ecran multifonction couleur',
              'Filtre a Pollen',
              'Fixation Isofix siege passager avant',
              'Fixations Isofix aux places arrieres',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Lunette arriere',
              'Miroir de courtoisie conducteur',
              'Miroir de courtoisie passager',
              'Ordinateur de bord',
              'Pedalier sport',
              'Retroviseur interieur electrochrome',
              'Siege conducteur avec reglage lombaire',
              'Siege conducteur reglable en hauteur',
              'Siege passager avec reglage lombaire',
              'Siege passager reglable en hauteur',
              'Sieges avant sport',
              'Tablette cache bagages',
              'Temperature exterieure',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en profondeur et hauteur'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Airbag conducteur',
              'Airbag passager',
              'Airbag passager deconnectable',
              'Airbags lateraux avant',
              'Airbags rideaux',
              'Antidemarrage electronique',
              'Antipatinage',
              'Ceintures avant ajustables en hauteur',
              'Controle elect. de la pression des pneus',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Reconnaissance panneaux de signalisation',
              'Systeme avance de detection d\'obstacles',
              'Systeme de prevention des collisions'
            ]
          }
        ],
        packs: [
          'Audi virtual cockpit plus',
          'Audi park assist',
          'Audi Phone box',
          'Jantes 19" gris titane mat',
          'MMI navigation avec MMI touch',
          'Noir Mythic metallise',
          'Pack dynamique plus',
          'Pack Assistance Route',
          'Pack eclairage d\'ambiance plus',
          'Volant Sport 3 branches multifonction en cuir avec meplat avec palettes de changement de vitesse pour S tronic',
          'Toit ouvrant coulissant/relevable electriquement',
          'Vitres surteintees (Privacy glass)',
          'Sieges avant chauffants'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/de/de5d30b0ef75aa74f3273e9dc5a3f69f.jpeg',
      name: 'Porsche Cayenne Coupe E-Hybrid V6 3.0',
      fullName: 'Porsche Cayenne Coupe E-Hybrid 3.0 V6 462ch / SUIVI COMPLET PORSCHE',
      price: '57 490 \u20AC',
      year: '2020',
      mileage: '123 000 km',
      fuel: 'Hybride',
      power: '462 ch',
      transmission: 'Automatique',
      badge: 'E-HYBRID',
      badgeColor: 'from-green-500 to-green-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3156328105',
      specs: {
        color: 'Noir',
        fiscalPower: '22 CV',
        doors: '5 portes',
        firstRegistration: '01/2020',
        warranty: '12 mois',
        seats: '5 places',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              'CarPlay',
              'Android Auto',
              'Bluetooth',
              'GPS',
              'Prise audio USB',
              'Telephone Bluetooth'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Key less go (demarrage sans cle)',
              'Suspension pilotee',
              'Allumage automatique des feux',
              'Chassis sport',
              'Detecteur de pluie',
              'Limiteur de vitesse',
              'Palettes au volant',
              'Regulateur de vitesse'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Crochet d\'attelage amovible',
              'Full LEDs',
              'Coffre electrique',
              'Camera de recul',
              'Jantes aluminium',
              'Peinture integrale',
              'Radar arriere de detection d\'obstacles',
              'Radar d\'aide au stationnement',
              'Retroviseurs degivrants',
              'Retroviseurs rabattables',
              'Retroviseurs electriques',
              'Toit panoramique'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Pare-brise athermique',
              'Retroviseur central electrochrome',
              'Sieges baquets',
              'Eclairage d\'ambiance',
              'Accoudoir central',
              'Climatisation automatique',
              'Climatisation multi zone',
              'Direction assistee',
              'Fermeture centralisee',
              'Ordinateur de bord',
              'Reglages du volant en hauteur',
              'Verrouillage a distance',
              'Vitres surteintees',
              'Vitres electriques',
              'Volant cuir'
            ]
          },
          {
            category: 'Sellerie',
            items: [
              'Sellerie cuir'
            ]
          },
          {
            category: 'Equipements supplementaires',
            items: [
              'Frein de parking automatique',
              'Kit de reparation',
              'Sieges arrieres rabattables',
              'Anti demarrage',
              'Predisposition telephone',
              'Sieges electriques',
              'Volant multifonctions',
              'Volant reglable'
            ]
          },
          {
            category: 'Securite',
            items: [
              'Airbags',
              'Controle de pression des pneus',
              'ABS',
              'Aide au demarrage en pente',
              'ESP',
              'Aide au freinage d\'urgence',
              'Anti-patinage',
              'Fixations ISOFIX',
              'Phares antibrouillard',
              'Radar avant de detection d\'obstacles'
            ]
          }
        ],
        packs: [
          'Acces Confort',
          'Affichage limitation vitesse + assist. changement de voie',
          'Assistance angles morts',
          'BOSE Surround Sound System',
          'Ceintures de securite Rouge Bordeaux',
          'Climatisation automatique 4 zones',
          'Eclairage d\'ambiance',
          'Ecusson Porsche sur appuie-tete avant',
          'Jantes 22" Cayenne Sport Classic',
          'Fond compteur chrono Rouge Bordeaux',
          'Pack Memoire Conducteur',
          'Pack Sport de conception allegee',
          'Pack interieur Carbone',
          'Pack interieur cuir',
          'Radars AR+AV + camera de recul + vue 360',
          'Regulateur vitesse adaptatif + assist. changement de voie',
          'Retros ext+int anti-eblouissement auto',
          'Sieges AV massants + ventiles',
          'Sieges AV chauffants',
          'Sorties d\'echappement sport',
          'Suspension pneumatique',
          'Vitrage arriere fume',
          'Volant en Carbone multifonction + chauffant'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/a6/a69a6c73f9662c96fbb0273d64465235.jpeg',
      name: 'Audi Q3 Sportback 1.5 e-hybrid 272ch S line',
      fullName: 'Audi Q3 Sportback III 1.5 e-hybrid 272ch S line S tronic 6',
      price: '58 990 \u20AC',
      year: '2025',
      mileage: '9 800 km',
      fuel: 'Hybride',
      power: '272 ch',
      transmission: 'Automatique (S tronic 6)',
      badge: 'S-LINE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3159466531',
      specs: {
        color: 'Noir',
        fiscalPower: '9 CV',
        doors: '5 portes',
        firstRegistration: '10/2025',
        warranty: '36 mois (Constructeur 10/2028)',
        co2: '39 g/km',
        description: 'Premiere main. Chez AUTO STAR, tous nos vehicules sont livres avec carnet d\'entretien a jour et double des cles, malus ecologique et taxe au poids inclus. Toutes les demarches administratives sont incluses, aucun frais supplementaire a prevoir. Reprise possible et livraison partout en France & DOM-TOM.',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '6 Haut parleurs',
              'Appel d\'Assistance Localise',
              'Appel d\'Urgence Localise',
              'Commandes du systeme audio au volant',
              'Commandes vocales',
              'Ecran tactile',
              'Fonction MP3',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Lecteur carte SD',
              'Prise USB',
              'Radio',
              'Radio numerique DAB',
              'Services connectes'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Capteur de luminosite',
              'Capteur de pluie',
              'Cle confort',
              'Follow me home',
              'Limiteur de vitesse',
              'Regulateur de vitesse'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Boucliers AV et AR couleur caisse',
              'Diffuseur AR noir',
              'Essuie-glace arriere',
              'Feux arriere a LED',
              'Feux de jour',
              'Jantes Alu',
              'Phares avant LED',
              'Radar de stationnement AR',
              'Repetiteurs de clignotant dans retro ext',
              'Retroviseurs electriques',
              'Spoiler AR'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir central AV',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 60/40',
              'Banquette AR rabattable',
              'Boite a gants fermee',
              'Clim manuelle',
              'Compte tours',
              'Ecran multifonction couleur',
              'Filtre a Pollen',
              'Fixation Isofix siege passager avant',
              'Fixations Isofix aux places arrieres',
              'Lampe de coffre',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Ordinateur de bord',
              'Pare-brise thermique',
              'Poches d\'aumonieres',
              'Rangement sous siege passager avant',
              'Siege conducteur reglable en hauteur',
              'Siege passager reglable en hauteur',
              'Sieges avant sport',
              'Temperature exterieure',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitrage calorifuge',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en hauteur',
              'Volant reglable en profondeur et hauteur'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Airbag conducteur',
              'Airbag passager',
              'Airbags lateraux avant',
              'Airbags rideaux',
              'Antidemarrage electronique',
              'Antipatinage',
              'Assistance de maintien de trajectoire',
              'Ceintures avant ajustables en hauteur',
              'Detecteur de sous-gonflage',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Reconnaissance panneaux de signalisation',
              'Systeme de prevention des collisions'
            ]
          }
        ],
        packs: [
          'Banquette AR plus avec accoudoir central et porte-gobelets',
          'Pack MMI Experience Pro',
          'Pack Tech Pro (Camera vue panoramique 360, Eclairage au sol, Regulateur de vitesse adaptatif, Retroviseur electrochrome rabattables electriquement a memoire, Siege avant electrique a memoire avec reglage lombaire, Systeme d\'acces sans cle, Systeme d\'alerte de vehicule en approche, Systeme d\'assistance au stationnement, Systeme d\'eclairage intelligent a LED, Systeme de controle des angles morts, Systeme de mesure de place disponible)',
          'Pack dynamique',
          'Projecteurs Audi digital Matrix LED',
          'Toit panoramique ouvrant en verre',
          'Pack climatisation plus',
          'Pack Esthetique Noir',
          'Pack Rangement',
          'Pack Rangement et coffre a bagages',
          'Volant sport multifonction en cuir a 3 branches, aplati en haut et en bas, avec palettes et chauffage de volant',
          'Vitrage Privacy (Lunette AR, vitres de portieres AR et vitres laterales AR surteintees)',
          'Tissu Novum Noir'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/65/651475c23c986000c49f705718efd53a.jpeg',
      name: 'Ford Ranger Raptor 3.0 Turbo',
      fullName: 'Ford Ranger Raptor 3.0 Turbo',
      price: '56 890 \u20AC',
      year: '2023',
      mileage: '34 000 km',
      fuel: 'Essence',
      power: '292 ch',
      transmission: 'Automatique',
      badge: 'RAPTOR',
      badgeColor: 'from-orange-500 to-orange-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/5d/5d8b78315c65194380f363a3fdf23a8b.jpeg',
      name: 'Renault Rafale Etech 1.2 Turbo Hybrid 200ch',
      fullName: 'Renault Rafale Etech 1.2 Turbo Hybrid 200ch',
      price: '48 500 \u20AC',
      year: '2026',
      mileage: '2 000 km',
      fuel: 'Hybride',
      power: '200 ch',
      transmission: 'Automatique',
      badge: 'E-TECH',
      badgeColor: 'from-green-500 to-green-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/e4/e41751ba858bfd5c0895e14c510ff54d.jpeg',
      name: 'Cupra Formentor E-Hybrid 1.5 TSI Turbo',
      fullName: 'Cupra Formentor E-Hybrid 1.5 TSI Turbo',
      price: '45 890 \u20AC',
      year: '2026',
      mileage: '2 000 km',
      fuel: 'Hybride',
      power: '272 ch',
      transmission: 'Automatique',
      badge: 'E-HYBRID',
      badgeColor: 'from-green-500 to-green-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/c4/c499f7554874622649ee691b672941e1.jpeg',
      name: 'Ford T.Custom 2.5 Duratech Hybride',
      fullName: 'Ford T.Custom 2.5 Duratech Hybride',
      price: '60 890 \u20AC',
      year: '2025',
      mileage: '17 000 km',
      fuel: 'Hybride',
      power: '232 ch',
      transmission: 'Automatique',
      badge: 'HYBRID',
      badgeColor: 'from-green-500 to-green-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/91/917584f1b2d1680b62f75d361391cbf2.jpeg',
      name: 'Audi S5 3.0 V6 Turbo Quattro',
      fullName: 'Audi S5 3.0 V6 Turbo Quattro',
      price: '56 200 \u20AC',
      year: '2021',
      mileage: '82 000 km',
      fuel: 'Essence',
      power: '354 ch',
      transmission: 'Automatique',
      badge: 'S5',
      badgeColor: 'from-blue-500 to-blue-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/22/22ae4a8f131987801b0cf30c24bd7d98.jpeg',
      name: 'BMW X2 sDrive 20i M Sport',
      fullName: 'BMW X2 (U10) sDrive20iA 170ch M Sport DKG7',
      price: '35 200 \u20AC',
      year: '2025',
      mileage: '27 500 km',
      fuel: 'Essence',
      power: '170 ch',
      transmission: 'Automatique',
      badge: 'M SPORT',
      badgeColor: 'from-blue-500 to-blue-600',
      link: '',
      specs: {
        color: 'Gris Brooklyn Grey metallise',
        fiscalPower: '6 CV',
        doors: '5 portes',
        firstRegistration: '01/2025',
        warranty: 'Garantie jusqu\'au 01/2028',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '6 Haut parleurs',
              'Appel d\'Urgence Localise',
              'Borne Wi-Fi',
              'Ecran tactile',
              'Fonction MP3',
              'GPS Cartographique',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Prise USB',
              'Radio',
              'Radio numerique DAB',
              'Services connectes',
              'TMC'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Capteur de luminosite',
              'Capteur de pluie',
              'Commande du comportement dynamique',
              'Demarrage sans cle',
              'Follow me home',
              'Guidage pour manoeuvre de stationnement',
              'Indicateur de limitation de vitesse',
              'Limiteur de vitesse',
              'Palettes changement vitesses au volant',
              'Regulateur de vitesse',
              'Regulateur de vitesse adaptatif',
              'Systeme d\'assistance a la descente'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Camera de recul',
              'Coffre assiste electriquement',
              'Feux arriere a LED',
              'Feux de jour a LED',
              'Feux de position a LED',
              'Filtre a particules',
              'Jantes Alu',
              'Phares avant LED',
              'Radar de stationnement AR',
              'Radar de stationnement AV',
              'Repetiteurs de clignotant dans retro ext',
              'Retroviseurs degivrants',
              'Retroviseurs rabattables electriquement',
              'Retroviseurs electriques',
              'Spoiler AR',
              'Systeme d\'assistance au stationnement',
              'Systeme d\'assistance au stationnement AR',
              'Systeme de mesure de place disponible'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir arriere',
              'Accoudoir central AV avec rangement',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 40/20/40',
              'Banquette AR rabattable',
              'Banquette arriere 3 places',
              'Boite a gant fermee',
              'Clim automatique bi-zones',
              'Compte tours',
              'Eclairage d\'ambiance',
              'Ecran multifonction couleur',
              'Filets de coffre',
              'Filtre a Pollen',
              'Fixations Isofix aux places arrieres',
              'Inserts de porte metal',
              'Lampe de coffre',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Lunette AR degivrante',
              'Miroir de courtoisie conducteur eclaire',
              'Miroir de courtoisie passager eclaire',
              'Ordinateur de bord',
              'Ouverture des vitres sequentielle',
              'Plancher de coffre mobile',
              'Porte-gobelets avant',
              'Prise 12V',
              'Siege conducteur chauffant',
              'Siege conducteur reglable en hauteur',
              'Siege passager chauffant',
              'Siege passager reglable en hauteur',
              'Temperature exterieure',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en profondeur et hauteur',
              'Volant sport'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Aide au freinage d\'urgence',
              'Airbag conducteur',
              'Airbag passager',
              'Airbag passager deconnectable',
              'Airbags lateraux arriere',
              'Airbags lateraux avant',
              'Airbags rideaux',
              'Alarme',
              'Antidemarrage electronique',
              'Antipatinage',
              'Assistance de maintien de trajectoire',
              'Controle de freinage en courbe',
              'Controle elect. de la pression des pneus',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Reconnaissance panneaux de signalisation',
              'Systeme avance de detection d\'obstacles',
              'Systeme d\'alerte de vehicule en approche',
              'Systeme de prevention des collisions'
            ]
          }
        ],
        packs: [
          'Systeme Hi-Fi Harman Kardon',
          'Peinture Brooklyn Grey metallise',
          'Similicuir perfore Veganza Schwarz (cuir noir)',
          'Crochet d\'attelage entierement automatique',
          'Drive Assist Plus / Pro (Assistance de maintien de trajectoire, Regulateur de vitesse adaptatif, Systeme avance de detection d\'obstacles, Systeme d\'alerte de vehicule en approche, Systeme de controle des angles morts, Systeme de prevention des collisions AR)',
          'Toit panoramique en verre',
          'Parking Assistant Professional',
          'Pack Innovation / Pack Premium (Affichage tete haute, Assistance de maintien de trajectoire, Camera vue panoramique 360, Regulateur de vitesse adaptatif, Retroviseur interieur electrochrome, Retroviseurs exterieurs electrochromes, Retroviseurs rabattables electriquement, Systeme d\'acces sans cle)',
          'Vitrage calorifuge (Lunette arriere surteintee, Vitres arriere surteintees)'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/ca/cac925d399bbff866352d1944713958c.jpeg',
      name: 'Audi Q3 Sportback S Line 45 TFSIe',
      fullName: 'Audi Q3 Sportback II 45 TFSIe S line S tronic 7',
      price: '41 290 \u20AC',
      year: '2023',
      mileage: '45 900 km',
      fuel: 'Hybride',
      power: '245 ch',
      transmission: 'Automatique (S tronic 7)',
      badge: 'S-LINE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: '',
      specs: {
        color: 'Gris Daytona nacre',
        fiscalPower: '8 CV',
        doors: '5 portes',
        firstRegistration: '04/2023',
        warranty: 'Constructeur jusqu\'au 04/2028',
        co2: '139 g/km',
        description: 'Premiere main. Chez AUTO STAR, tous nos vehicules sont livres avec carnet d\'entretien a jour et double des cles. Toutes les demarches administratives sont incluses, aucun frais supplementaire a prevoir. Reprise possible et livraison partout en France & DOM-TOM.',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '6 Haut parleurs',
              'Appel d\'Urgence Localise',
              'Borne Wi-Fi',
              'Commandes vocales',
              'Ecran tactile',
              'Fonction MP3',
              'GPS Cartographique',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Lecteur carte SD',
              'Prise USB',
              'Prise auxiliaire de connexion audio',
              'Radio numerique DAB',
              'Services connectes',
              'TMC',
              'Volume automatique de la radio'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Capteur de luminosite',
              'Capteur de pluie',
              'Chassis Sport',
              'Commande du comportement dynamique',
              'Limiteur de vitesse',
              'Regulateur de vitesse',
              'Suspensions Sport'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Becquet arriere',
              'Coffre assiste electriquement',
              'Diffuseur AR noir',
              'Eclairage statique d\'intersection',
              'Feux de freinage d\'urgence',
              'Feux de jour a LED',
              'Feux de position a LED',
              'Filtre a particules',
              'Jantes Alu',
              'Pare-brise acoustique',
              'Phares avant LED',
              'Poignees ton carrosserie',
              'Radar de stationnement AR',
              'Radar de stationnement AV',
              'Retroviseurs degivrants',
              'Retroviseurs ext. indexes a la marche AR',
              'Retroviseurs rabattables automatiquement',
              'Retroviseurs rabattables electriquement',
              'Retroviseurs electriques'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir arriere',
              'Accoudoir central AV avec rangement',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 40/20/40',
              'Banquette AR rabattable',
              'Banquette coulissante',
              'Boite a gant fermee',
              'Clim automatique bi-zones',
              'Compte tours',
              'Eclairage d\'ambiance',
              'Ecran multifonction couleur',
              'Filtre a Pollen',
              'Fixations Isofix aux places arrieres',
              'Inserts de porte metal',
              'Inserts de tableau de bord metal',
              'Lampe de coffre',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Miroir de courtoisie conducteur eclaire',
              'Miroir de courtoisie passager',
              'Ordinateur de bord',
              'Ouverture des vitres sequentielle',
              'Pare-brise thermique',
              'Porte-gobelets arriere',
              'Porte-gobelets avant',
              'Prise 12V',
              'Pedalier sport',
              'Retroviseur interieur electrochrome',
              'Siege cond. avec reglage lombaire electrique',
              'Siege conducteur reglable en hauteur',
              'Siege passager avec reglage lombaire',
              'Siege passager reglable en hauteur',
              'Sieges avant sport',
              'Tablette cache bagages',
              'Temperature exterieure',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en profondeur et hauteur'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Aide au freinage d\'urgence',
              'Airbag conducteur',
              'Airbag passager',
              'Airbag passager deconnectable',
              'Airbags lateraux avant',
              'Airbags rideaux AV et AR',
              'Antidemarrage electronique',
              'Antipatinage',
              'Assistance de maintien de trajectoire',
              'Ceintures avant ajustables en hauteur',
              'Controle elect. de la pression des pneus',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Reconnaissance panneaux de signalisation',
              'Systeme de controle des angles morts',
              'Systeme de prevention des collisions',
              'Troisieme ceinture de securite'
            ]
          }
        ],
        packs: [
          'Audi connect navigation et divertissement plus',
          'Audi smartphone interface',
          'Cle confort incluant deverrouillage (Demarrage sans cle, Ouverture du coffre mains-libres, Systeme d\'acces sans cle)',
          'Assistant maintien de vitesse adaptatif',
          'Gris Daytona nacre',
          'Audi park assist',
          'Phares Matrix LED avec clignotants dynamiques a l\'arriere',
          'Retroviseurs exterieurs reglables, degivrants, rabattables electriquement avec fonction rabat automatique et memoire',
          'Toit ouvrant panoramique',
          'Camera de recul 360',
          'Jantes 18 pouces design S Line',
          'Pack eclairage d\'ambiance plus/multicolore',
          'Sieges avant chauffants',
          'Amortissement pilote + Audi drive select',
          'Audi virtual cockpit plus',
          'Extension garantie 2 ans supplementaires / 120 000 km'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/96/96e7b802c0dd11877b20c81334e5644b.jpeg',
      name: 'Kia Sportage 1.6 GDI 4WD GT Line',
      fullName: 'Kia Sportage 1.6 GDI 4WD GT Line',
      price: '32 650 \u20AC',
      year: '2025',
      mileage: '1 500 km',
      fuel: 'Hybride',
      power: '210 ch',
      transmission: 'Automatique',
      badge: 'GT LINE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3163099071'
    },
    {
      image: 'https://static.lumi.new/material/e2/e26e2dea9b40f8c828ceff9ebfb2a0f9.jpeg',
      name: 'Nissan Qashqai E-Power 190ch N-Design',
      fullName: 'Nissan Qashqai E-Power 190ch N-Design',
      price: '28 490 \u20AC',
      year: '2025',
      mileage: '11 700 km',
      fuel: 'Hybride',
      power: '190 ch',
      transmission: 'Automatique',
      badge: 'N-DESIGN',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3162873594'
    },
    {
      image: 'https://static.lumi.new/material/85/85989df0d0cdff8fd31dbc29d201ae80.jpeg',
      name: 'BMW X1 18d sDrive M Sport',
      fullName: 'BMW X1 III (U11) sDrive18d 150ch M Sport',
      price: '42 890 \u20AC',
      year: '2025',
      mileage: '12 500 km',
      fuel: 'Diesel',
      power: '150 ch',
      transmission: 'Automatique',
      badge: 'M SPORT',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3162814345',
      specs: {
        color: 'GRIS metallise',
        fiscalPower: '8 CV',
        doors: '5 portes',
        firstRegistration: '06/2025',
        warranty: 'Garantie jusqu\'au 06/2028',
        description: 'Premiere main. Chez AUTO STAR, tous nos vehicules sont livres avec carnet d\'entretien a jour et double des cles. Toutes les demarches administratives sont incluses, aucun frais supplementaire a prevoir. Reprise possible et livraison partout en France & DOM-TOM.',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '6 Haut parleurs',
              'Appel d\'Assistance Localise',
              'Appel d\'Urgence Localise',
              'Borne Wi-Fi',
              'Commandes du systeme audio au volant',
              'GPS Cartographique',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Prise USB',
              'Radio',
              'Radio numerique DAB',
              'Services connectes',
              'TMC'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Capteur de pluie',
              'Capteur de luminosite',
              'Commande du comportement dynamique',
              'Demarrage sans cle',
              'Follow me home',
              'Indicateur de limitation de vitesse',
              'Limiteur de vitesse',
              'Palettes changement vitesses au volant',
              'Regulateur de vitesse'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Boucliers AV et AR couleur caisse',
              'Camera de recul',
              'Coffre assiste electriquement',
              'Eclairage au sol',
              'Eclairage statique d\'intersection',
              'Feux arriere a LED',
              'Feux de freinage d\'urgence',
              'Feux de jour a LED',
              'Filtre a particules',
              'Jantes Alu',
              'Phares avant LED',
              'Poignees ton carrosserie',
              'Radar de stationnement AR',
              'Radar de stationnement AV',
              'Repetiteurs de clignotant dans retro ext',
              'Retroviseurs degivrants',
              'Retroviseurs electriques',
              'Systeme d\'assistance au stationnement',
              'Systeme de mesure de place disponible'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir arriere',
              'Accoudoir central AV avec rangement',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 40/20/40',
              'Banquette AR rabattable',
              'Clim automatique bi-zones',
              'Eclairage d\'ambiance',
              'Ecran multifonction couleur',
              'Filets de coffre',
              'Filtre a Pollen',
              'Fixations Isofix aux places arrieres',
              'Inserts de porte metal',
              'Inserts de tableau de bord metal',
              'Lampe de coffre',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Miroir de courtoisie conducteur eclaire',
              'Miroir de courtoisie passager eclaire',
              'Ordinateur de bord',
              'Ouverture des vitres sequentielle',
              'Poches d\'aumonieres',
              'Porte-gobelets arriere',
              'Porte-gobelets avant',
              'Prise 12V',
              'Siege conducteur reglable en hauteur',
              'Siege passager reglable en hauteur',
              'Sieges avant sport',
              'Temperature exterieure',
              'Verrouillage auto. des portes en roulant',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en profondeur et hauteur',
              'Volant sport'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Airbag conducteur',
              'Airbag passager',
              'Airbag passager deconnectable',
              'Airbags lateraux avant',
              'Airbags rideaux',
              'Airbags rideaux AR',
              'Antidemarrage electronique',
              'Antipatinage',
              'Assistance de maintien de trajectoire',
              'Controle de freinage en courbe',
              'Controle elect. de la pression des pneus',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Systeme avance de detection d\'obstacles',
              'Systeme de detection de somnolence',
              'Systeme de prevention des collisions'
            ]
          }
        ],
        packs: [
          'BMW Individual Storm Bay metallise',
          'Drive Assist Plus / Pro (Assistance de maintien de trajectoire, Regulateur de vitesse adaptatif, Systeme avance de detection d\'obstacles, Systeme d\'alerte de vehicule en approche, Systeme de controle des angles morts, Systeme de prevention des collisions AR)',
          'Garantie etendue 2 ans + 1 an (200 000 km)',
          'Jantes 20 style 869 Gris fonce',
          'Parking Assistant Professional',
          'Pack Confort',
          'Pack Premium',
          'Sieges avant electriques a memoires conducteur',
          'Shadow Line M brillant etendu',
          'Storm Bay metallisee BMW Individual',
          'Systeme Hi-Fi Harman Kardon',
          'Volant chauffant'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/8a/8ad3b4504e91b384396a51ee3fc384f5.jpeg',
      name: 'BMW X1 20i sDrive 170ch',
      fullName: 'BMW X1 20i sDrive 170ch',
      price: '33 490 \u20AC',
      year: '2024',
      mileage: '26 000 km',
      fuel: 'Essence',
      power: '170 ch',
      transmission: 'Automatique',
      badge: 'sDRIVE',
      badgeColor: 'from-blue-500 to-blue-600',
      link: 'https://www.leboncoin.fr/ad/voitures/3167036708'
    },
    {
      image: 'https://static.lumi.new/material/56/5621b8447d6a0aa9b4fcee8a58d5a215.jpeg',
      name: 'BMW X1 18d sDrive M Sport',
      fullName: 'BMW X1 III (U11) sDrive18d 150ch M Sport',
      price: '35 900 \u20AC',
      year: '2024',
      mileage: '26 700 km',
      fuel: 'Diesel',
      power: '150 ch',
      transmission: 'Automatique',
      badge: 'M SPORT',
      badgeColor: 'from-blue-500 to-blue-600',
      link: '',
      specs: {
        color: 'Noir Saphirschwarz metallise',
        fiscalPower: '8 CV',
        doors: '5 portes',
        firstRegistration: '08/2024',
        warranty: 'Garantie jusqu\'au 06/2028',
        description: 'Chez AUTO STAR, tous nos vehicules sont livres avec carnet d\'entretien a jour et double des cles. Toutes les demarches administratives sont incluses, aucun frais supplementaire a prevoir. Reprise possible et livraison partout en France & DOM-TOM.',
        equipments: [
          {
            category: 'Audio - Telecommunications',
            items: [
              '6 Haut parleurs',
              'Appel d\'Assistance Localise',
              'Appel d\'Urgence Localise',
              'Borne Wi-Fi',
              'Commandes du systeme audio au volant',
              'GPS Cartographique',
              'Interface Media',
              'Kit mains-libres Bluetooth',
              'Prise USB',
              'Radio',
              'Radio numerique DAB',
              'Services connectes',
              'TMC'
            ]
          },
          {
            category: 'Conduite',
            items: [
              'Aide au demarrage en cote',
              'Arret et redemarrage auto. du moteur',
              'Capteur de pluie',
              'Capteur de luminosite',
              'Commande du comportement dynamique',
              'Demarrage sans cle',
              'Follow me home',
              'Indicateur de limitation de vitesse',
              'Limiteur de vitesse',
              'Palettes changement vitesses au volant',
              'Regulateur de vitesse'
            ]
          },
          {
            category: 'Exterieur',
            items: [
              'Boucliers AV et AR couleur caisse',
              'Camera de recul',
              'Coffre assiste electriquement',
              'Eclairage au sol',
              'Eclairage statique d\'intersection',
              'Feux arriere a LED',
              'Feux de freinage d\'urgence',
              'Feux de jour a LED',
              'Filtre a particules',
              'Jantes Alu',
              'Phares avant LED',
              'Poignees ton carrosserie',
              'Radar de stationnement AR',
              'Radar de stationnement AV',
              'Repetiteurs de clignotant dans retro ext',
              'Retroviseurs degivrants',
              'Retroviseurs electriques',
              'Systeme d\'assistance au stationnement',
              'Systeme de mesure de place disponible'
            ]
          },
          {
            category: 'Interieur',
            items: [
              'Accoudoir arriere',
              'Accoudoir central AV avec rangement',
              'Appui-tete conducteur reglable hauteur',
              'Appui-tete passager reglable en hauteur',
              'Bacs de portes arriere',
              'Bacs de portes avant',
              'Banquette 40/20/40',
              'Banquette AR rabattable',
              'Clim automatique bi-zones',
              'Eclairage d\'ambiance',
              'Ecran multifonction couleur',
              'Filets de coffre',
              'Filtre a Pollen',
              'Fixations Isofix aux places arrieres',
              'Inserts de porte metal',
              'Inserts de tableau de bord metal',
              'Lampe de coffre',
              'Lampes de lecture a l\'arriere',
              'Lampes de lecture a l\'avant',
              'Miroir de courtoisie conducteur eclaire',
              'Miroir de courtoisie passager eclaire',
              'Ordinateur de bord',
              'Ouverture des vitres sequentielle',
              'Poches d\'aumonieres',
              'Porte-gobelets arriere',
              'Porte-gobelets avant',
              'Prise 12V',
              'Siege conducteur reglable en hauteur',
              'Siege passager reglable en hauteur',
              'Sieges avant sport',
              'Temperature exterieure',
              'Verrouillage auto. des portes en roulant',
              'Verrouillage centralise des portes',
              'Verrouillage centralise a distance',
              'Vitres arriere electriques',
              'Vitres avant electriques',
              'Volant cuir',
              'Volant multifonction',
              'Volant reglable en profondeur et hauteur',
              'Volant sport'
            ]
          },
          {
            category: 'Securite',
            items: [
              'ABS',
              'AFIL',
              'Airbag conducteur',
              'Airbag passager',
              'Airbag passager deconnectable',
              'Airbags lateraux avant',
              'Airbags rideaux',
              'Airbags rideaux AR',
              'Antidemarrage electronique',
              'Antipatinage',
              'Assistance de maintien de trajectoire',
              'Controle de freinage en courbe',
              'Controle elect. de la pression des pneus',
              'EBD',
              'ESP',
              'Freinage automatique d\'urgence',
              'Systeme avance de detection d\'obstacles',
              'Systeme de detection de somnolence',
              'Systeme de prevention des collisions'
            ]
          }
        ],
        packs: [
          'BMW Saphirschwarz metallisee',
          'Drive Assist Plus / Pro (Assistance de maintien de trajectoire, Regulateur de vitesse adaptatif, Systeme avance de detection d\'obstacles, Systeme d\'alerte de vehicule en approche, Systeme de controle des angles morts, Systeme de prevention des collisions AR)',
          'Garantie etendue 2 ans + 2 ans',
          'Parking Assistant Professional',
          'Pack Confort',
          'Pack Premium',
          'Shadow Line M brillant etendu'
        ]
      }
    },
    {
      image: 'https://static.lumi.new/material/76/76592d9748e5b1c971be3d2333e8a253.jpeg',
      name: 'Mercedes GLA 200d',
      fullName: 'Mercedes-Benz GLA 200d',
      price: '37 990 \u20AC',
      year: '2022',
      mileage: '37 500 km',
      fuel: 'Diesel',
      power: '150 ch',
      transmission: 'Automatique',
      badge: 'GLA',
      badgeColor: 'from-gray-500 to-gray-600',
      link: ''
    },
    {
      image: 'https://static.lumi.new/material/00/00b8a133e110a03be8bd9d6c3839a919.jpeg',
      name: 'Mercedes GLE 350e Hybride',
      fullName: 'Mercedes-Benz GLE 350e Hybride 333ch',
      price: '58 700 \u20AC',
      year: '',
      mileage: '',
      fuel: 'Hybride',
      power: '333 ch',
      transmission: 'Automatique',
      badge: 'HYBRID',
      badgeColor: 'from-green-500 to-green-600',
      link: ''
    }
  ]

  const openModal = (vehicle: VehicleSpec) => {
    setSelectedVehicle(vehicle)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedVehicle(null)
  }

  return (
    <>
      <section id="vehicules" className="bg-black py-16 sm:py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 md:mb-20 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <span className="text-blue-400 font-bold text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 block">Nos vehicules</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 px-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              Selection <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-white to-red-500">exclusive</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-2xl mx-auto px-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Decouvrez notre collection de vehicules premium
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
            {vehicles.map((vehicle, idx) => (
              <div 
                key={idx}
                onClick={() => openModal(vehicle)}
                className="cursor-pointer block"
              >
                <div 
                  className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl sm:rounded-2xl md:rounded-3xl overflow-hidden hover:border-blue-400/30 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/20 animate-in fade-in slide-in-from-bottom-8 duration-700"
                  style={{ animationDelay: `${idx * 0.15}s` }}
                >
                  <div className="relative overflow-hidden h-48 sm:h-56 md:h-64">
                    <img 
                      src={vehicle.image} 
                      alt={vehicle.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
                    <div className={`absolute top-3 sm:top-4 right-3 sm:right-4 bg-gradient-to-r ${vehicle.badgeColor} px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-white text-xs font-bold shadow-lg`}>
                      {vehicle.badge}
                    </div>
                    {vehicle.specs ? (
                      <div className="absolute bottom-3 left-3 bg-blue-500/90 backdrop-blur-sm px-3 py-1 rounded-full text-white text-xs font-bold flex items-center gap-1.5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                        Fiche technique
                      </div>
                    ) : null}
                  </div>

                  <div className="p-5 sm:p-6 md:p-8">
                    <h3 className="text-white font-black text-lg sm:text-xl md:text-2xl mb-2 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>{vehicle.name}</h3>
                    <div className="text-2xl sm:text-2xl md:text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-500 mb-5 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>
                      {vehicle.price}
                    </div>

                    <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 sm:gap-y-3 mb-5 sm:mb-6">
                      <div className="flex items-center gap-3 text-white/70">
                        <Calendar size={18} className="text-blue-400 flex-shrink-0" />
                        <span className="text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{vehicle.year}</span>
                      </div>
                      <div className="flex items-center gap-3 text-white/70">
                        <Gauge size={18} className="text-white flex-shrink-0" />
                        <span className="text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{vehicle.mileage}</span>
                      </div>
                      <div className="flex items-center gap-3 text-white/70">
                        <Fuel size={18} className="text-red-400 flex-shrink-0" />
                        <span className="text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{vehicle.fuel}</span>
                      </div>
                      {vehicle.power ? (
                        <div className="flex items-center gap-3 text-white/70">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-400 flex-shrink-0"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                          <span className="text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{vehicle.power}</span>
                        </div>
                      ) : null}
                      {vehicle.transmission ? (
                        <div className="flex items-center gap-3 text-white/70 col-span-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white flex-shrink-0"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                          <span className="text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{vehicle.transmission}</span>
                        </div>
                      ) : null}
                    </div>

                    <button className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-3 sm:py-3.5 md:py-4 rounded-full font-bold text-xs sm:text-sm md:text-base hover:from-blue-500 hover:to-blue-400 transition-all flex items-center justify-center gap-2 group-hover:scale-105 shadow-lg">
                      {vehicle.specs ? 'Voir la fiche technique' : 'En savoir plus'}
                      <ArrowRight className="group-hover:translate-x-1 transition-transform flex-shrink-0" size={18} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10 sm:mt-12 md:mt-16 animate-in fade-in slide-in-from-bottom-4 duration-700" style={{ animationDelay: '0.5s' }}>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border-2 border-white/20 text-white px-6 sm:px-8 md:px-10 py-3.5 sm:py-4 md:py-5 rounded-full font-bold text-sm sm:text-base md:text-lg hover:bg-white/20 hover:border-blue-400/50 transition-all hover:scale-105 group"
            >
              Voir tous les vehicules
              <ArrowRight className="group-hover:translate-x-1 transition-transform flex-shrink-0" size={20} />
            </a>
          </div>
        </div>
      </section>

      <VehicleModal 
        vehicle={selectedVehicle} 
        isOpen={isModalOpen} 
        onClose={closeModal} 
      />
    </>
  )
}
